/**
 * SunFlare — decorative overlay that adds a warm golden-hour glow
 * + subtle lens flare on top of an image. Use as absolute layer inside
 * a relative parent containing an <img>.
 */
export default function SunFlare({ intensity = "soft", side = "top-right" }) {
  const opacity = intensity === "strong" ? 0.85 : intensity === "medium" ? 0.65 : 0.5;
  const position =
    side === "top-left"
      ? { from: "10% 12%", flareLeft: "12%", flareTop: "14%" }
      : { from: "88% 14%", flareLeft: "82%", flareTop: "18%" };

  return (
    <>
      {/* Warm radial wash */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background: `radial-gradient(circle at ${position.from}, rgba(255,228,164,0.85) 0%, rgba(255,206,128,0.45) 18%, rgba(255,184,92,0) 45%)`,
          mixBlendMode: "screen",
          opacity,
        }}
      />
      {/* Soft golden warmth tint over the whole image */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, rgba(255,217,150,0.18) 0%, rgba(255,194,140,0.06) 40%, rgba(0,0,0,0) 70%)",
          mixBlendMode: "soft-light",
        }}
      />
      {/* Lens flare — small bright dot + ring + smaller artefacts */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `
            radial-gradient(circle at ${position.flareLeft} ${position.flareTop}, rgba(255,255,240,0.85) 0%, rgba(255,235,180,0.5) 1.2%, rgba(255,235,180,0) 3%),
            radial-gradient(circle at ${position.flareLeft} ${position.flareTop}, rgba(255,250,210,0) 4%, rgba(255,250,210,0.18) 4.4%, rgba(255,250,210,0) 5%),
            radial-gradient(circle at 62% 42%, rgba(255,210,140,0.18) 0%, rgba(255,210,140,0) 1.5%),
            radial-gradient(circle at 48% 58%, rgba(255,200,140,0.12) 0%, rgba(255,200,140,0) 1%)
          `,
          mixBlendMode: "screen",
        }}
      />
    </>
  );
}
